import * as marietta from '../../..';

class InnerColorMenu {
    viewObj: Element;

    tabInnerWall: Element;

    tabInnerFloor: Element;

    tabInnerDoor: Element;

    tabInnerHabaki: Element;

    tabInnerCurtain: Element;

    floorTextureCategory: any;

    /**
     * コンストラクタ
     */
    constructor() {
      this.viewObj = document.querySelector('#itemChangeMenu_naiheki');
      this.tabInnerWall = document.querySelector('#tabInnerWall');
      this.tabInnerFloor = document.querySelector('#tabInnerFloor');
      this.tabInnerDoor = document.querySelector('#tabInnerDoor');
      this.tabInnerHabaki = document.querySelector('#tabInnerHabaki');
      // this.tabInnerCurtain = document.querySelector('#tabInnerCurtain');
      this.floorTextureCategory = {
        white: {
          'title' : 'ホワイト系',
          'title_en' : 'White',
        },
        light: {
          'title' : 'ライト系',
          'title_en' : 'Light',
        },
        medium: {
          'title' : 'ミディアム系',
          'title_en' : 'Medium',
        },
        dark: {
          'title' : 'ダーク系',
          'title_en' : 'Dark',
        },
      };
    }

    /**
     * 初期化
     */
    init() {
      this.viewObj.querySelectorAll('.tabContents').forEach((elem) => {
        const tabcontLen = elem.children.length;
        if (tabcontLen > 0) {
          for (let i = 0; i < tabcontLen; i += 1) {
            elem.children[0].remove();
          }
        }
      });
      this.createMaterialList();

      this.viewObj.querySelectorAll('.tabMenu').forEach((elem) => {
        elem.querySelectorAll('label')[0].click();
      });
    }

    /**
     * カラー（テクスチャ）リストの生成
     */
    createMaterialList() {
      let contents = '';
      // 情報をGET
      const clothData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Cloth);
      const floorData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Floor);
      const doorData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Door);
      const habakiData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Habaki);
      // const curtainData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Curtain);

      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (clothData !== undefined) {
        for (let i = 0; i < clothData.length; i += 1) {
          contents += `<li data-itemindex="${String(i)}" class="btnChangeWallColor"><button id="changeInnerColorWall${String(i)}"><img src="${clothData[i].thumbnail}" width="48" height="48"/><div class="currentFrame"></div><p>${clothData[i].name}</p></button></li>`;
        }
      }

      contents += '</ul>';

      const element = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };

      this.tabInnerWall.appendChild(element(contents));

      document.querySelectorAll('.btnChangeWallColor').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
          marietta.view3d.webcad.View3dGlobal.shared.changeWallColor(itemIndex);
        });
      });

      const groupByCategory = this.getFloorDataGroup(floorData);
      // コンテンツの作成
      let floorContent = '';
      // eslint-disable-next-line no-restricted-syntax
      // eslint-disable-next-line no-restricted-syntax
      for (const category in groupByCategory) {
        if (groupByCategory.hasOwnProperty(category)) {
          floorContent += `<span class="category floorTextureCategory" id="floorTextureCategory_${String(category)}"><span class="jp">${this.floorTextureCategory[category].title}</span><span class="en">${this.floorTextureCategory[category].title_en}</span></span>`;
          floorContent += '<ul>';
          if (groupByCategory[category] !== undefined) {
            for (let i = 0; i < groupByCategory[category].length; i += 1) {
              const floorIndex = floorData.findIndex((floor) => floor.name === groupByCategory[category][i].name);
              floorContent += `<li  data-itemindex="${String(floorIndex)}" class="btnChangeFloorColor category"><button id="changeInnerColorFloor${String(floorIndex)}"><img src="${groupByCategory[category][i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${groupByCategory[category][i].name}</p></button></li>`;
            }
          }
          floorContent += '</ul>';
        }
      }
      this.tabInnerFloor.insertAdjacentHTML( 'beforeend', floorContent);
      document.querySelectorAll('.btnChangeFloorColor').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
          marietta.view3d.webcad.View3dGlobal.shared.changeFloorColor(itemIndex);
        });
      });
      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (doorData !== undefined) {
        for (let i = 0; i < doorData.length; i += 1) {
          contents += `<li  data-itemindex="${String(i)}" class="btnChangeItemColor" data-itemtype="1" ><button id="changeFitColorDoor${String(i)}"><p class="texture" style="background:#${doorData[i].color}"/><div class="currentFrame"></div><p>${doorData[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const doorElement = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabInnerDoor.appendChild(doorElement(contents));

      // コンテンツの作成
      // contents = '';
      // contents += '<ul>';
      // if (curtainData !== undefined) {
      //   for (let i = 0; i < curtainData.length; i += 1) {
      //     contents += `<li data-itemindex="${String(i)}" class="btnChangeItemColor" data-itemtype="3" ><button id="changeFitColorCurtain${String(i)}"><p class="texture" style="background:#${curtainData[i].color}"/><div class="currentFrame"></div><p>${curtainData[i].name}</p></button></li>`;
      //   }
      // }
      // contents += '</ul>';
      // const curtainElement = (html): HTMLElement => {
      //   const tempEl = document.createElement('div');
      //   tempEl.innerHTML = html;
      //   return tempEl.firstElementChild as HTMLElement;
      // };
      // this.tabInnerCurtain.appendChild(curtainElement(contents));

      // コンテンツの作成
      contents = '';
      contents += '<ul>';
      if (habakiData !== undefined) {
        for (let i = 0; i < habakiData.length; i += 1) {
          contents += `<li  data-itemindex="${String(i)}" class="btnChangeHabaki"><button id="changeHabaki${String(i)}"><img src="${habakiData[i].thumbnail}" width="64" height="64"/><div class="currentFrame"></div><p>${habakiData[i].name}</p></button></li>`;
        }
      }
      contents += '</ul>';
      const habakiElement = (html): HTMLElement => {
        const tempEl = document.createElement('div');
        tempEl.innerHTML = html;
        return tempEl.firstElementChild as HTMLElement;
      };
      this.tabInnerHabaki.appendChild(habakiElement(contents));

      document.querySelectorAll('.btnChangeHabaki').forEach((elem) => {
        elem.addEventListener('click', (e) => {
          const itemIndex = Number(((e.currentTarget) as HTMLElement).getAttribute('data-itemindex'));
          marietta.view3d.webcad.View3dGlobal.shared.changeHabakiColor(itemIndex);
        });
      });

      // カレントを表示
      this.initCurrentTexture();

      const self = this;
      (self.tabInnerWall).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabInnerFloor).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabInnerDoor).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      (self.tabInnerHabaki).querySelectorAll('li').forEach((elem) => {
        elem.addEventListener('click', self.updateCurrentTexture);
      });
      // (self.tabInnerCurtain).querySelectorAll('li').forEach((elem) => {
      //   elem.addEventListener('click', self.updateCurrentTexture);
      // });
    }

    /**
     *
     * @param floorData
     */
    // eslint-disable-next-line class-methods-use-this
    getFloorDataGroup(floorData: any) {
      const groupByCategory = floorData.reduce((group, floor) => {
        const { category } = floor;
        group[category] = group[category] ?? [];
        group[category].push(floor);
        group[category]
        return group;
      }, {});
      let groupData = {};
      // eslint-disable-next-line no-restricted-syntax
      //floorTextureCategory キーに基づいてデータを並べ替える
      for (const category in this.floorTextureCategory) {
        if (groupByCategory[category]) {
          groupData[category] = groupByCategory[category];
        }
      }
      return groupData;
    }

    /**
     * 選択状態の更新
     */
    initCurrentTexture() {
      // 情報をGET
      const clothData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Cloth);
      const floorData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Floor);
      const doorData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Door);
      const curtainData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Curtain);
      const habakiData = marietta.view3d.webcad.View3dGlobal.shared.getMaterialList(marietta.view3d.webcad.ItemType.Habaki);

      const groupByCategory = this.getFloorDataGroup(floorData);

      // カレントを表示
      const self = this;
      clothData.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabInnerWall').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabInnerWall').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });

      let floorIndex = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const category in groupByCategory) {
        if (groupByCategory.hasOwnProperty(category)) {
          if (groupByCategory[category] !== undefined) {
            for (let i = 0; i < groupByCategory[category].length; i += 1) {
              if (groupByCategory[category][i].selected) {
                (self.viewObj).querySelector('#tabInnerFloor').querySelectorAll('li')[floorIndex].classList.add('is-active');
              } else {
                (self.viewObj).querySelector('#tabInnerFloor').querySelectorAll('li')[floorIndex].classList.remove('is-active');
              }
              floorIndex += 1;
            }
          }
        }
      }

      doorData.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabInnerDoor').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabInnerDoor').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });

      habakiData.forEach((obj, index) => {
        if (obj.selected) {
          (self.viewObj).querySelector('#tabInnerHabaki').querySelectorAll('li')[index].classList.add('is-active');
        } else {
          (self.viewObj).querySelector('#tabInnerHabaki').querySelectorAll('li')[index].classList.remove('is-active');
        }
      });

      if ((self.viewObj).querySelector('#tabInnerHabaki').querySelectorAll('li.is-active').length === 0) {
        (self.viewObj).querySelector('#tabInnerHabaki').querySelectorAll('li')[0].classList.add('is-active');
      }

      // curtainData.forEach((obj, index) => {
      //   if (obj.selected) {
      //     (self.viewObj).querySelector('#tabInnerCurtain').querySelectorAll('li')[index].classList.add('is-active');
      //   } else {
      //     (self.viewObj).querySelector('#tabInnerCurtain').querySelectorAll('li')[index].classList.remove('is-active');
      //   }
      // });
    }

    /**
     * 選択中のテクスチャをカレント表示
     */
    updateCurrentTexture = (e) => {
      (e.currentTarget).closest('.tabContent').querySelectorAll('li').forEach((elem) => {
        elem.classList.remove('is-active');
      });
      (e.currentTarget).classList.add('is-active');
    }
}
export default InnerColorMenu;
